import { BillType, DEFAULT_UTILITY_SURCHARGE_EXEMPTION, UtilitySurchargeExemption } from '../../types/general'

export const getPositiveAmount = (value: unknown) => {
  const amount = Number(value)
  return Number.isFinite(amount) && amount > 0 ? amount : 0
}

export const getTotalBillAmount = (bills: BillType[]) =>
  bills.reduce((total, bill) => total + getPositiveAmount(bill.phai_thu), 0)

/**
 * Phí tiện ích của 1 giao dịch, khớp với backend (calcUtilitySurcharge):
 * - Miễn phí khi trường bật cấu hình, mọi phiếu là vãng lai và tổng phải thu dưới ngưỡng
 * - Ngược lại = trung bình phí tiện ích các phiếu (chia cho tổng số phiếu), làm tròn
 */
export const getTotalServiceFee = (bills: BillType[], exemption?: UtilitySurchargeExemption) => {
  if (bills.length === 0) return 0

  if (exemption?.enabled) {
    const threshold = exemption.threshold ?? DEFAULT_UTILITY_SURCHARGE_EXEMPTION.threshold
    const isAllVangLai = bills.every((bill) => !!bill.is_vang_lai)
    if (isAllVangLai && getTotalBillAmount(bills) < threshold) return 0
  }

  const totalFee = bills.reduce((sum, bill) => sum + getPositiveAmount(bill.so_tien_phu_thu_tien_ich), 0)
  return Math.round(totalFee / bills.length)
}

export const getTotalPaymentAmount = (bills: BillType[], exemption?: UtilitySurchargeExemption) =>
  getTotalBillAmount(bills) + getTotalServiceFee(bills, exemption)

export const getPaymentAmountWithServiceFee = (
  amount: number,
  bills: BillType[],
  exemption?: UtilitySurchargeExemption,
) => getPositiveAmount(amount) + getTotalServiceFee(bills, exemption)
